<template>
  <div>
    <div v-if="loading">
      <v-progress-linear
        class="mx-2"
        color="primary"
        indeterminate
      ></v-progress-linear>
    </div>

    <div v-if="attendance">
      <div class="mb-2">
        <v-breadcrumbs class="px-0" :items="breadcrumbsItems" color="primary"> </v-breadcrumbs>
      </div>
      <div class="mb-6">
        <!-- <h3>{{ attendance.date }}</h3> -->
        <h2>
          {{ dateString }} : {{ attendance.nurseryUser.lastName
          }}{{ attendance.nurseryUser.firstName }}
        </h2>
      </div>
      <div class="mb-4">
        <div>出勤時刻</div>
        <!-- <v-text-field
        variant="outlined"
        type="datetime-local"
        v-model="attendedAt"
      ></v-text-field> -->
        <v-text-field variant="outlined" type="time" v-model="attendedAt"></v-text-field>
      </div>
      <div class="mb-4">
        <div>退勤時刻</div>
        <v-text-field variant="outlined" type="time" v-model="leftAt"></v-text-field>
        <!-- <v-text-field
        variant="outlined"
        type="datetime-local"
        v-model="leftAt"
      ></v-text-field> -->
      </div>
      <v-row justify="center">
        <v-btn
          color="primary"
          variant="flat"
          x-large
          :disabled="isSaving"
          @click="save"
          >保存</v-btn
        >
      </v-row>
      <v-row justify="center" class="pt-10">
        <v-btn
          @click="deleteAttendance"
          :disabled="isSaving"
          color="error"
          variant="outlined"
          x-large
          >出勤・退勤削除</v-btn
        >
      </v-row>

      <div>
        <v-progress-linear
          v-if="isSaving"
          indeterminate
          color="primary"
          class="my-8"
        ></v-progress-linear>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import { attendanceEditModule } from "@/store/dataModules/attendanceEditModule";
import { staffAttandanceEditModule } from "@/store/viewModules/timecard/staffAttendanceEditModule";
import dayjs from "dayjs";
import ApiAttendance from "@/api/ApiAttendance";
import LocalDataService from "@/service/LocalDataService";
import { TimecardResponse } from "chaild-api/lib";
import ApiTimecard from "@/api/ApiTimecard";
import Swal from "sweetalert2";

interface DataType {
  isSaving: boolean;
  loading: boolean;
}

export default defineComponent({
  computed: {
    attendance() {
      return staffAttandanceEditModule.attendance;
    },
    attendedAt: {
      get(): string | null {
        if (
          staffAttandanceEditModule.attendance &&
          staffAttandanceEditModule.attendance.attendedAt
        ) {
          // return dayjs(attendanceEditModule.attendance.attendedAt).format('YYYY-MM-DDTHH:mm');
          return dayjs(staffAttandanceEditModule.attendance.attendedAt).format(
            "HH:mm"
          );
        }
        return null;
      },
      set(value: string) {
        if (this.date && value && this.attendance) {
          const _attendance = { ...this.attendance } as TimecardResponse;
          const date = dayjs(this.date + value).toISOString();
          _attendance.attendedAt = date;
          staffAttandanceEditModule.setAttendance(_attendance);
          // attendanceEditModule.setAttendedAtValue(date);
        }
      },
    },
    leftAt: {
      get(): string | null {
        if (
          staffAttandanceEditModule.attendance &&
          staffAttandanceEditModule.attendance.leftAt
        ) {
          // return dayjs(attendanceEditModule.attendance.leftAt).format('YYYY-MM-DDTHH:mm');
          return dayjs(staffAttandanceEditModule.attendance.leftAt).format(
            "HH:mm"
          );
        }
        return null;
      },
      set(value: string) {
        if (this.date && value && this.attendance) {
          const _attendance = { ...this.attendance } as TimecardResponse;
          const date = dayjs(this.date + value).toISOString();
          _attendance.leftAt = date;
          staffAttandanceEditModule.setAttendance(_attendance);
        }
      },
    },
    date(): string | undefined {
      const p = this.$route.params.date;
      return typeof p === "string" ? p : p?.[0];
    },
    dateString() {
      const p = this.$route.params.date;
      const date = typeof p === "string" ? p : p?.[0];
      if (date) {
        return dayjs(date).format("YYYY年MM月DD日");
      }
      return null;
    },
    breadcrumbsItems(): Array<{ title: string; href?: string; disabled?: boolean }> {
      return [
        { title: "勤怠管理", href: "/staffAttendance/list" },
        { title: "出勤・退勤編集", href: "", disabled: true },
      ];
    },
  },

  data: (): DataType => {
    return {
      isSaving: false,
      loading: false,
    };
  },

  methods: {
    async getAttendance() {
      const userIdParam = this.$route.params.userId;
      const dateParam = this.$route.params.date;
      const userId = typeof userIdParam === "string" ? userIdParam : userIdParam?.[0];
      const date = typeof dateParam === "string" ? dateParam : dateParam?.[0];
      if (userId && date) {
        await staffAttandanceEditModule.getAttendance({
          userId,
          date,
        });
      }
      // this.loading = true;
      // await attendanceEditModule.getAttendance();
      // this.loading = false;
    },
    async save() {
      this.isSaving = true;
      const userIdParam = this.$route.params.userId;
      const dateParam = this.$route.params.date;
      const userId = typeof userIdParam === "string" ? userIdParam : userIdParam?.[0];
      const date = typeof dateParam === "string" ? dateParam : dateParam?.[0];
      if (userId && date && this.attendance) {
        await ApiTimecard.updateStaffAttendance({
          date,
          userId,
          attendedAt: this.attendance.attendedAt || undefined,
          leftAt: this.attendance.leftAt || undefined,
        })
          .then(() => {
            Swal.fire({ title: "更新しました", icon: "success" });
          })
          .catch(() => {
            alert(
              "保存できませんでした。売上情報を確定している場合などは、編集できません。"
            );
          });
      }
      this.isSaving = false;
    },
    async deleteAttendance() {
      this.isSaving = true;
      const userIdParam = this.$route.params.userId;
      const dateParam = this.$route.params.date;
      const userId = typeof userIdParam === "string" ? userIdParam : userIdParam?.[0];
      const date = typeof dateParam === "string" ? dateParam : dateParam?.[0];
      if (userId && date && this.attendance) {
        await ApiTimecard.updateStaffAttendance({
          date,
          userId,
          attendedAt: null,
          leftAt: null,
        })
          .then(() => {
            Swal.fire({ title: "更新しました", icon: "success" });
          })
          .catch(() => {
            alert(
              "保存できませんでした。売上情報を確定している場合などは、編集できません。"
            );
          });
      }
      this.getAttendance();
      this.isSaving = false;
    },
  },

  mounted() {
    const dateParam = this.$route.params.date;
    const userIdParam = this.$route.params.userId;
    const date = typeof dateParam === "string" ? dateParam : dateParam?.[0];
    const userId = typeof userIdParam === "string" ? userIdParam : userIdParam?.[0];

    if (date && userId) {
      try {
        this.getAttendance();
      } catch {
        return;
      }
    }
  },
});
</script>
